import React, { PureComponent } from 'react';
import { css } from '@emotion/css';
import { theme } from '@branchjs/neo-components';
import Icons from '../../../../../styles/Icons';
import StatusLabel from '../StatusLabel';

const selectionListItemStyles = {
  container: css({
    backgroundColor: theme.colors.primary.contrastWhite,
    height: 35,
    margin: '5px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `0.7px solid ${theme.colors.gray[200]}`,
    borderRadius: 5,
  }),
  contentContainerLeft: css({
    color: theme.colors.gray[800],
    fontSize: theme.typography.body2.fontSize,
    height: 18,
    marginLeft: 8,
  }),
  contentContainerRight: css({
    display: 'flex',
  }),
  closeIcon: css({
    fontFamily: 'Material Icons',
    fontSize: theme.typography.body2.fontSize,
    color: theme.colors.gray[400],
    marginLeft: 15,
    paddingRight: 5,
    cursor: 'pointer',
  }),
};

class SelectionListItem extends PureComponent {
  render() {
    const { container, contentContainerLeft, contentContainerRight, closeIcon } = selectionListItemStyles;
    const { selection, onRemoveSelection, secondaryLabelKey, statusLabelType } = this.props;
    return (
      <div className={container}>
        <div className={contentContainerLeft}>{selection.value}</div>
        <div className={contentContainerRight}>
          {secondaryLabelKey && <StatusLabel text={selection[secondaryLabelKey]} type={statusLabelType} />}
          <span className={closeIcon} onClick={() => onRemoveSelection(selection)}>
            {Icons.CLOSE}
          </span>
        </div>
      </div>
    );
  }
}

export default SelectionListItem;
